import React from 'react';
import { useNavigate } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userPartnerCalcList.module.scss';
//compWrapper
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트//div
//comp
import ImgArea from 'src/webapp/views/component/ImgArea';
import Button from 'src/webapp/views/component/Button';//버튼엘리먼트
import EmptyData from 'src/webapp/views/component/data/EmptyData';//데이터없음

export default function List({list, checkedList, setCheckedList}) {
    const navigator = useNavigate();//navigator

    /* ==================== 체크박스선택 ==================== */
    const onCheckedHandler = (e, item) => {
        const checked = e.target.checked;
        setCheckedList(checked ? [...checkedList, item] : checkedList.filter((checkedItems) => checkedItems != item));
    }
    /* ==================== 체크박스선택 ==================== */

    return ( 
        <>
        {list.length > 0 ? 
        <Element tag={`div`} className={styles.listArea}>
            <Element tag={`ul`}>
                {list.map((item, i) => (
                    <Element tag={`li`} key={item.SEQ_NO}>
                        <input type='checkbox'
                            disabled={item.CALC_YN === 'Y' ? true : false} 
                            checked={checkedList.includes(item) ? true : false} 
                            onChange={(e) => onCheckedHandler(e, item)} />
                        <ImgArea className={["imgArea", styles.imgArea].join(" ")} src={item.IMG_SRC !== undefined ? item.IMG_SRC : null} alt={item.PARTNER_NAME} />
                        <Element tag={`div`}><Element tag={`label`} style={{width: "8.5rem"}}>{item.PARTNER_NAME}</Element></Element><hr />
                        <Element tag={`div`} className={styles.dateArea}><FontAwesomeIcon icon="fa-light fa-calendar" /><Element tag={`span`} style={{width: "10.625rem"}}>{item.CALC_START_DATE + ' ~ ' + item.CALC_END_DATE}</Element></Element><hr />
                        <Element tag={`div`} className={styles.dateArea}><FontAwesomeIcon icon="fa-light fa-calendar" /><Element tag={`span`} style={{width: "5.5875rem"}}>{item.CALC_DATE}</Element></Element><hr />
                        <Element tag={`div`} className={styles.priceArea}><FontAwesomeIcon icon="fa-light fa-coins" /><Element tag={`em`} style={{width: "5.0625rem"}}>{item.TYPE === 1 ? item.TOT_AMT : null}</Element></Element><hr />
                        <Element tag={`div`} className={styles.priceArea}><FontAwesomeIcon icon="fa-light fa-coins" /><Element tag={`em`} style={{width: "5.0625rem"}}>{item.CALC_AMT}</Element></Element><hr />
                        <Element tag={`div`} className={styles.stretch}><Element tag={item.CALC_YN === 'Y' ? `h4` : `h5`}>
                            {item.CALC_YN === 'Y' ? '완료' : item.CALC_YN === 'N' ? '예정' : null}</Element>
                        </Element>
                        <Element tag={`div`}>
                            <Button anyprop={(e) => navigator(`/payment/partners/calc/detail`, {state:item})} icon={"fa-light fa-chevron-right"} />
                        </Element>
                    </Element>
                ))}
            </Element> 
        </Element>
        : <EmptyData /> }
        </>
    );
}